import {Box, Stack, useTheme} from "@mui/material";
import React from "react";
import {CervinoHeaderText} from "../components/typography/CervinoHeaderText";
import {FlippingCard} from "../components/layout/FlippingCard";
import {ResponsiveStack} from "../components/layout/Grids/ResponsiveStack";
import { recipeCards } from "../data/moments";
import SMFooter from "../components/marketing/SMFooter";
import MarketingPhrasesRowV2 from "../components/marketing/MarketingPhrasesRowV2";
import iconUrl from "../assets/icons/SM_star.png";
import IconDividerLine from "../components/marketing/IconDividerLine";
import design1 from "../assets/icons/SM_long_flower_black.png";
import design2 from "../assets/icons/SM_short_flower_black.png";
import DecorativeSidePattern from "../components/layout/DecorativeSidePattern";

export default function MomentsPage() {
    const theme = useTheme();
    const [openId, setOpenId] = React.useState(null);

    return (
        <Box sx={{ position: "relative" }}>
            <Stack sx={{ position: "relative", zIndex: 1 }}>
                <Stack alignItems="center" textAlign="center">
                    <DecorativeSidePattern
                        design1={design1}
                        design2={design2}
                        seed={5}
                        opacity={0.15}
                        zIndex={0}
                        density={{ xs: 1, sm: 1, md: 1.05, lg: 1.1, xl: 1.15 }}
                        cellSize={{ xs: 420, sm: 520, md: 650, lg: 780, xl: 920 }}
                        sizeRange={{
                            xs: [320, 450],
                            sm: [420, 600],
                            md: [520, 750],
                            lg: [650, 900],
                            xl: [750, 1100],
                        }}
                        collisionPadding={0}
                        rotateRange={[-30, 30]}
                        allowFlip={false}
                    />

                    <Box paddingTop={{ xs: 10, sm: 15 }}>
                        <MarketingPhrasesRowV2
                            phrases={["Send us how it turned out"]}
                            iconSrc={iconUrl}
                            iconRepeat={2}
                            iconSize={{ xs: 30, sm: 35 }}
                            gap={{ xs: 1, sm: 2 }}
                            color={theme.palette.primary.main}
                            rotateIcon
                        />
                    </Box>

                    {/* 👇 START DECORATION HERE */}
                    <Box sx={{ position: "relative", width: "100%" }}>

                        {/* Everything below this is layered above the pattern */}
                        <Box sx={{ position: "relative", zIndex: 1 }}>
                            <CervinoHeaderText
                                color={theme.palette.primary.main}
                                sx={{
                                    fontSize: { xs: "1.8rem", sm: "3rem", md: "4rem", lg: "5rem", xl: "6rem" }
                                }}
                            >
                                YOUR RECIPES & YOUR MOMENTS
                            </CervinoHeaderText>

                            <IconDividerLine
                                iconSrc={iconUrl}
                                iconSize={{ xs: 30, sm: 30, md: 40, lg: 40, xl: 40 }}
                                iconGap={1}
                                rotateIcon
                                pixelsPerSecond={30}
                            />

                            <ResponsiveStack
                                columns={{ xs: 2, sm: 2, md: 2, lg: 4, xl: 4 }}
                                itemMaxWidth={{ xs: 170, sm: 220, md: 300, lg: 320, xl: 380 }}
                                itemHeight={{ xs: 290, sm: 300, md: 360, lg: 380, xl: 440 }}
                                rowSpacing={{ xs: 1, sm: 2, md: 3, lg: 3, xl: 3 }}
                                columnSpacing={{ xs: 2, sm: 3, md: 3, lg: 3, xl: 6 }}
                                sx={{ paddingBottom: 3 }}
                            >
                                {recipeCards.map((r, idx) => (
                                    <FlippingCard
                                        key={r.title}
                                        id={idx}
                                        openId={openId}
                                        setOpenId={setOpenId}
                                        {...r}
                                    />
                                ))}
                            </ResponsiveStack>
                        </Box>
                    </Box>
                </Stack>

                <SMFooter />
            </Stack>
        </Box>
    );
}
